import React, { Fragment, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { isEmpty, keys } from 'lodash-es';


import TopPublishersTable from '../components/TopPublishersTable';
import Header from '../../shared/components/Header';
import RelatedAppStoreAnalitics from '../../shared/components/RelatedAppStoreAnalitics';
import TopChartsFilters from '../../shared/components/TopChartsFilters';
import LoadingOverlay from '../../../../../components/LoadingOverlay';
import { initParams, parseUrlForFilters } from '../configs';
import helpers from '../../../../../utils/helpers';

// Static configs
const {
  report, shareOptions, data, availableCategories
} = initParams();
const enableTopFilters = ['store', 'categories', 'countries'];

const PageContainer = () => {
  useEffect(() => {
    const onPopstate = () => window.location.reload();
    window.addEventListener('popstate', onPopstate);
    return () => window.removeEventListener('popstate', onPopstate);
  }, []);
  const baseUrl = ({ store, category, country }) => `${window.location.origin}/top-charts/top-publishers/${store}/${category}/${country}`;

  const p = parseUrlForFilters();

  const handleFilterChange = useCallback((filter) => {
    const defaultParsedURL = !filter.store && (keys(p).length === 1 && p.store === undefined);
    const defaultStore =
      (filter.store && (
        filter.store === 'itunes-connect'
        || filter.store === 'itunes_connect'))
      || defaultParsedURL
      || (!filter.store && p.store === 'itunes-connect');
    const defaultFilters = {
      category: defaultStore ? 'top-overall' : 'overall',
      country: 'united-states',
      store: defaultStore ? 'itunes-connect' : 'google-play',
    };
    const countrySlug = filter.country &&
      helpers.convertToSlug(COUNTRIES_ARRAY[filter.country]);
    const categorySlug = availableCategories[filter.category];
    const allFilters = {
      store: (filter.store || defaultParsedURL) ? defaultFilters.store : p.store,
      category: categorySlug || (filter.store && defaultFilters.category) || p.category || defaultFilters.category,
      country: countrySlug || p.country || defaultFilters.country,
    };
    window.location.assign(`${baseUrl(allFilters)}`);
  }, []);

  const handleShowMore = useCallback(() => {
    document.getElementById('schedule-a-demo-modal').classList.add('in');
  }, []);
  const childComponent = (
    <RelatedAppStoreAnalitics
      store={report.store}
      type="Publishers"
    />
  );
  const renderPortal = () => ReactDOM.createPortal(childComponent, document.getElementById('related-publishers-store-analytics'));

  const headline = <span>Top <span className="text-blue">{data.store_name}</span> Publishers</span>;

  const subheadline = `Free app store rank data for *${data.category_name}* in the ${data.country_name}`;

  return (
    <Fragment>
      <LoadingOverlay loading={isEmpty(data)} />
      <Fragment>
        <Header
          headline={headline}
          subheadline={subheadline}
        />
        <section className="top-charts-publishers-content container">
          <TopChartsFilters
            onFilterChange={handleFilterChange}
            filters={data}
            enableTopFilters={enableTopFilters}
            shareOptions={shareOptions}
          />
          <TopPublishersTable
            report={report}
            onShowMore={handleShowMore}
          />
        </section>
      </Fragment>
      {renderPortal()}
    </Fragment>
  );
};

export default PageContainer;
